import { useState } from 'react';
import { useAuth } from '@/contexts/AuthContext';
import { Button } from '@/components/ui/button';
import { Sparkles, ExternalLink, X } from 'lucide-react';

const WHATSAPP_URL =
    'https://wa.me/50379557231?text=Hola,%20me%20gustar%C3%ADa%20adquirir%20un%20plan%20para%20mi%20gimnasio%20en%20GymPro%20SV';

export function TrialBanner() {
    const { gym, user } = useAuth();
    const [justDismissed, setJustDismissed] = useState(false);
    const storageKey = `gympro_trial_banner_dismissed_${gym?.gym_id}_${new Date().toDateString()}`;
    const dismissed =
        justDismissed ||
        (typeof localStorage !== 'undefined' && localStorage.getItem(storageKey) === 'true');

    if (!gym || user?.role === 'super_admin') return null;
    if (!gym.is_trial) return null;
    if (gym.status !== 'active') return null;
    if (!gym.expiry_date) return null;

    const expiry = new Date(gym.expiry_date);
    const daysLeft = Math.ceil((expiry.getTime() - Date.now()) / (1000 * 60 * 60 * 24));

    // La prueba ya venció: el TrialOverlay (pantalla completa) se encarga.
    if (daysLeft <= 0) return null;
    if (dismissed) return null;

    const isUrgent = daysLeft <= 5;

    return (
        <div
            className={`flex flex-wrap items-center justify-between gap-2 px-4 lg:px-6 py-2 text-white ${isUrgent ? 'bg-red-600' : 'bg-orange-600'
                }`}
        >
            <div className="flex items-center gap-2 text-xs lg:text-sm font-bold">
                <Sparkles className="h-4 w-4 shrink-0" />
                <span>
                    Prueba gratuita: te {daysLeft === 1 ? 'queda' : 'quedan'}{' '}
                    <strong>
                        {daysLeft} {daysLeft === 1 ? 'día' : 'días'}
                    </strong>
                    . Adquiere un plan para no perder acceso.
                </span>
            </div>
            <div className="flex items-center gap-2">
                <Button
                    size="sm"
                    className="h-7 bg-white text-slate-900 hover:bg-white/90 font-bold text-xs rounded-lg"
                    onClick={() => window.open(WHATSAPP_URL, '_blank')}
                >
                    Adquirir plan
                    <ExternalLink className="ml-1 h-3.5 w-3.5" />
                </Button>
                <button
                    aria-label="Ocultar"
                    className="text-white/80 hover:text-white"
                    onClick={() => {
                        localStorage.setItem(storageKey, 'true');
                        setJustDismissed(true);
                    }}
                >
                    <X className="h-4 w-4" />
                </button>
            </div>
        </div>
    );
}
